import React from "react";

const star = () => {
    return (
        <svg viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.516 7.34073L11.6803 1.69097C11.3809 0.769704 10.0775 0.769644 9.77809 1.69098L7.94242 7.34073H2.00192C1.03321 7.34073 0.630407 8.58034 1.41414 9.14975L6.2201 12.6415L4.38438 18.2912C4.08504 19.2125 5.13948 19.9787 5.92323 19.4093L10.7292 15.9175L15.5352 19.4093C16.3189 19.9787 17.3734 19.2126 17.074 18.2912L15.2383 12.6415L20.0443 9.14975C20.828 8.58034 20.4252 7.34073 19.4565 7.34073H13.516Z"
                stroke="black"
                strokeWidth="1.8"
            />
        </svg>
    );
};

export default React.memo(star);
